import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function FinalCTA() {
  return <section className="py-32 px-4 md:px-8 bg-gradient-to-b from-carbon to-[#0a0a0a]" data-id="element-30">
      <div className="max-w-3xl mx-auto text-center" data-id="element-31">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.8,
        ease: [0.22, 1, 0.36, 1]
      }} className="p-8 md:p-12 rounded-2xl border border-gold/20 bg-gold/5 backdrop-blur-sm shadow-[0_0_50px_rgba(242,183,5,0.05)]" data-id="element-32">
          <h2 className="text-3xl md:text-5xl font-black text-white mb-6" data-id="element-33">
            Agenda tu consulta estratégica gratuita
          </h2>
          <p className="text-gray-400 text-lg md:text-xl mb-10 max-w-2xl mx-auto" data-id="element-34">
            Descubre cómo el Sistema A.C.E.™ Clínico puede transformar tu
            agenda y multiplicar los ingresos de tu clínica en los próximos 30
            días.
          </p>
          <CTAButton text="QUIERO LLENAR MI AGENDA CLÍNICA" className="w-full md:w-auto md:px-12 md:py-5 text-xl" data-id="element-35" />
        </motion.div>
      </div>
    </section>;
}